import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getCartSimpleItems = createSelector(cartState, (cart) => cart.itemsSimple);
